import { render, staticRenderFns } from "./Idle.vue?vue&type=template&id=65987368&scoped=true"
import script from "./Idle.vue?vue&type=script&lang=js"
export * from "./Idle.vue?vue&type=script&lang=js"
import style0 from "./Idle.vue?vue&type=style&index=0&id=65987368&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65987368",
  null
  
)

export default component.exports